/** @jsx jsx */
import { BuilderBlocks } from '@builder.io/react';
import { jsx, Box } from 'theme-ui';
import { Themed } from '@theme-ui/mdx';

const Table = ({ columns, rows, builderBlock }) => (
  <Box>
    <table>
      <thead>
        <tr>
          {columns.map((column) => (
            <Themed.th key={column.label} sx={{ textAlign: column.textAlign }}>
              {column.label}
            </Themed.th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={rowIndex}>
            {row.columns.map((col, colIndex) => (
              <td key={col.content[0].id}>
                <BuilderBlocks
                  parentElementId={builderBlock.id}
                  dataPath={`component.options.rows.${rowIndex}.columns.${colIndex}.content`}
                  child
                  blocks={col.content}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </Box>
);

export default Table;
